var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddPlusCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 38,
    viewBox: "0 0 38 38",
    width: 38,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#181818",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    transform: "translate(1.288 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.712 0c9.942 0 18 8.058 18 18s-8.058 18-18 18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.562 34.898c-1.992-.726-3.824-1.778-5.416-3.114"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.146 4.216c1.592-1.338 3.424-2.39 5.416-3.114"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 14.876c.37-2.106 1.102-4.084 2.134-5.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 21.122c.37 2.106 1.102 4.084 2.134 5.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.712 13.34v9.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.372 18h-9.32"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m-5-5h48v48h-48z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPlusCircle);
export default __webpack_public_path__ + "static/media/add-plus-circle.8b3bd80f6f7fe8d5c914a471f8c27566.svg";
export { ForwardRef as ReactComponent };